import { render, staticRenderFns } from "./taskAdd.vue?vue&type=template&id=690d17a2&scoped=true"
import script from "./taskAdd.vue?vue&type=script&lang=js"
export * from "./taskAdd.vue?vue&type=script&lang=js"
import style0 from "./taskAdd.vue?vue&type=style&index=0&id=690d17a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d17a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690d17a2')) {
      api.createRecord('690d17a2', component.options)
    } else {
      api.reload('690d17a2', component.options)
    }
    module.hot.accept("./taskAdd.vue?vue&type=template&id=690d17a2&scoped=true", function () {
      api.rerender('690d17a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/taskAdd.vue"
export default component.exports